<script>
export default {
  name: "CommerceConnectorOnlineShop",
  getShops(shopDataList, config) {
    let shopResult = [];
    for (let shopData of shopDataList) {
      if (this.isProductAvailable(shopData, config.maxDeliveryTime)) {
        shopResult.push({
          id: shopData.Id,
          name: shopData.Name,
          deeplink: shopData.OfferInfo.Offers[0].Deeplink,
          logo: this.getLogo(shopData)
        });
      }
    }
    return shopResult;
  },
  isProductAvailable(shopData, maxDeliveryTime) {
    let availability = false;
    if (shopData.OfferInfo) {
      availability = shopData.OfferInfo.Offers[0].AvailabilityInfo[0];
    }
    if (maxDeliveryTime !== false) {
      return (
        availability &&
        parseInt(availability.DeliveryTime) <= maxDeliveryTime &&
        parseInt(availability.DeliveryTime) !== 0
      );
    } else {
      return (
        parseInt(availability.DeliveryTime) > 0 ||
        parseInt(availability.DeliveryTime) == -1
      );
    }
  },

  getLogo(shopData) {
    const logoProps = ["LogoLarge", "LogoMedium", "LogoSmall"];

    const shopLogoData = shopData.Logos[0];

    for (let logoProp of logoProps) {
      if (shopLogoData[logoProp]) {
        return ["//", shopLogoData[logoProp]].join("");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CommerceConnectorOnlineShop.vue